import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldFooter } from '@lichtblick/photon/atoms/field-footer';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { ExclamationMarkTriangleXs } from '@lichtblick/photon/icons/symbols/exclamation-mark-triangle-xs';
import classNames from 'classnames';
import Image from 'next/image';
import { useState } from 'react';
import styles from './action-buttons.module.scss';
export const ActionButtons = ({ columns = 2, currentValue, name, options, errorMessage, required })=>{
    const [error, setError] = useState();
    const [isTouched, setIsTouched] = useState(false);
    const validate = (input)=>// required is the only validation making sense for ActionButtons
        setError(input.validity.valid ? undefined : 'Hier fehlt noch eine Angabe');
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.root,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: classNames(styles.container, columns === 2 && styles['two-cols']),
                children: options.map(({ imageData, title, value })=>/*#__PURE__*/ _jsxs("label", {
                        className: classNames(styles.label, (errorMessage || error) && styles.error),
                        "data-testid": `${name}-${value}`,
                        children: [
                            /*#__PURE__*/ _jsx("input", {
                                className: styles.input,
                                defaultChecked: currentValue === value,
                                name: name,
                                type: "radio",
                                value: value,
                                onBlur: (event)=>{
                                    setIsTouched(true);
                                    validate(event.currentTarget);
                                },
                                onInput: (event)=>{
                                    if (isTouched || error) {
                                        validate(event.currentTarget);
                                    }
                                },
                                onInvalid: (event)=>{
                                    event.preventDefault();
                                    validate(event.currentTarget);
                                },
                                required: required
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                bold: true,
                                children: title
                            }),
                            imageData && /*#__PURE__*/ _jsx(Image, {
                                alt: title,
                                className: styles.image,
                                height: imageData.height,
                                src: imageData.src,
                                width: imageData.width
                            })
                        ]
                    }, value))
            }),
            (errorMessage || error) && /*#__PURE__*/ _jsx(FieldFooter, {
                className: styles['error-message'],
                "data-testid": "field-error",
                error: true,
                icon: /*#__PURE__*/ _jsx(ExclamationMarkTriangleXs, {}),
                children: errorMessage ?? error
            })
        ]
    });
};

//# sourceMappingURL=action-buttons.js.map